/**
 * Two-letter US state + DC codes. Matches the set of per-state tables
 * (`voter_data.voter_file_<state>`) we import via the voter-import job.
 */

export const US_STATE_CODES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY',
  'DC',
] as const

export type StateCode = (typeof US_STATE_CODES)[number]

export function isStateCode(value: unknown): value is StateCode {
  return typeof value === 'string' && (US_STATE_CODES as readonly string[]).includes(value)
}

/** Accepts any casing / whitespace. Returns undefined for falsy or unknown values. */
export function normalizeStateCode(value: string | null | undefined): StateCode | undefined {
  if (!value) return undefined
  const upper = value.trim().toUpperCase()
  return isStateCode(upper) ? upper : undefined
}
